export const EMAIL_TEMPLATES_LIST = {
  EMAIL_TITLE: { key: 'EMAIL_TITLE', value: 'Email' },
  EMAIL_DESCRIPTION: {
    key: 'EMAIL_DESCRIPTION',
    value:
      'Design, edit, update your mail templates, reusables used in the mail templates and referenced contents',
  },
  ADD_NEW_EMAIL_TOOLTIP: {
    key: 'ADD_NEW_EMAIL',
    value: 'Add new email template',
  },
  LOADING_MORE: {
    key: 'LOADING_MORE',
    value: 'Loading more...',
  },
  GOT_ALL_TEMPLATES_LIST: {
    key: 'GOT_ALL_TEMPLATES_LIST',
    value: 'You have got all results',
  },
  DELETE_TEMPLATE_DROPDOWN_OPTION: {
    key: 'DELETE_TEMPLATE',
    value: 'Delete',
  },
  EDIT_TEMPLATE_DROPDOWN_OPTION: {
    key: 'EDIT_TEMPLATE',
    value: 'Edit',
  },
  EMPTY_TEMPLATES_LIST: { key: 'EMPTY_TEMPLATES_LIST', value: 'Templates list is empty. Click' },
  CREATE_NEW_TEMPLATE_INFO: {
    key: 'CREATE_NEW_TEMPLATE_INFO',
    value: 'to create new template',
  },
  CREATE_NEW_TEMPLATE_ACTION: { key: 'CREATE_NEW_TEMPLATE_ACTION', value: 'here' },
};

export const ADVANCED_FILTER = {
  ADVANCED_FILTER_TITLE: {
    key: 'FILTER_TITLE',
    value: 'Advanced Search',
  },
  FILTER_CLEAR_ALL: {
    key: 'FILTER_CLEAR_ALL',
    value: 'Clear all filter',
  },
  FILTER_SEARCH_BUTTON: {
    key: 'FILTER_SEARCH_BUTTON',
    value: 'Search',
  },
  FILTER_BY_NAME_LABEL: {
    key: 'FILTER_BY_NAME_LABEL',
    value: 'Search by name',
  },
  FILTER_BY_NAME_PLACEHOLDER: {
    key: 'FILTER_BY_NAME_PLACEHOLDER',
    value: 'Search by name',
  },
  FILTER_BY_CATEGORY_LABEL: {
    key: 'FILTER_BY_CATEGORY_LABEL',
    value: 'Categories',
  },
  FILTER_BY_STATUS_LABEL: {
    key: 'FILTER_BY_STATUS_LABEL',
    value: 'Status',
  },
  FILTER_WAITING_FOR_APPROVAL_LABEL: {
    key: 'FILTER_WAITING_FOR_APPROVAL_LABEL',
    value: 'waiting for approval',
  },
  FILTER_BY_TAGS_LABEL: {
    key: 'FILTER_BY_TAGS_LABEL',
    value: 'search by tags',
  },
  FILTER_BY_TAGS_PLACEHOLDER: {
    key: 'FILTER_BY_TAGS_PLACEHOLDER',
    value: 'search by tags',
  },
  FILTER_SHOW_ALL_CATEGORIES_ACTION: {
    key: 'FILTER_SHOW_ALL_CATEGORIES_ACTION',
    value: 'more categories',
  },
  EMPTY_CATEGORIES_LIST: {
    key: 'EMPTY_CATEGORIES_LIST',
    value: 'Categories list is empty',
  },
  LANGUAGE_SEARCH_FILTER_LABEL: {
    key: 'LANGUAGE_SEARCH_FILTER_LABEL',
    value: 'Search By Language',
  },
  ALL_OPTION: {
    key: 'ALL_OPTION',
    value: 'All',
  },
};

export const DOCUMENT_AND_EMAIL_ELEMENTS_LIST = {
  REFERENCED_ELEMENT_TITLE: { key: 'REFERENCED_ELEMENT_TITLE', value: 'Referenced' },
  REUSABLE_ELEMENT_TITLE: { key: 'REUSABLE_ELEMENT_TITLE', value: 'Reusable' },
  ADD_NEW_REFERENCED_ELEMENT_TOOLTIP: {
    key: 'ADD_NEW_REFERENCED_ELEMENT_TOOLTIP',
    value: 'Add new referenced element',
  },
  ADD_NEW_REUSABLE_ELEMENT_TOOLTIP: {
    key: 'ADD_NEW_REUSABLE_ELEMENT_TOOLTIP',
    value: 'Add new reusable element',
  },
  LOADING_MORE: {
    key: 'LOADING_MORE',
    value: 'Loading more...',
  },
  GOT_ALL_ELEMENTS_LIST: {
    key: 'GOT_ALL_ELEMENTS_LIST',
    value: 'You have got all results',
  },
  DELETE_ELEMENT_DROPDOWN_OPTION: {
    key: 'DELETE_ELEMENT_DROPDOWN_OPTION',
    value: 'Delete',
  },
  EDIT_ELEMENT_DROPDOWN_OPTION: {
    key: 'EDIT_ELEMENT_DROPDOWN_OPTION',
    value: 'Edit',
  },
  ELEMENTS_LIST_EMPTY_TEXT: { key: 'ELEMENTS_LIST_EMPTY_TEXT', value: 'Elements list is empty' },
};

export const  REUSABLE_SECTION_DESIGN  = {
  REUSABLE_SECTION_BUTTON: { key: 'REUSABLE_SECTION_BUTTON', value: 'Reusable sections' },
  ADD_NEW_REUSABLE_SECTION_TOOLTIP: {
    key: 'ADD_NEW_REUSABLE_SECTION_TOOLTIP',
    value: 'Add new Reusable section',
  },
}
